var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0625 5.96875H8.84375V1.75C8.84375 1.25195 8.4043 0.8125 7.90625 0.8125H6.96875C6.44141 0.8125 6.03125 1.25195 6.03125 1.75V5.96875H1.8125C1.28516 5.96875 0.875 6.4082 0.875 6.90625V7.84375C0.875 8.37109 1.28516 8.78125 1.8125 8.78125H6.03125V13C6.03125 13.5273 6.44141 13.9375 6.96875 13.9375H7.90625C8.4043 13.9375 8.84375 13.5273 8.84375 13V8.78125H13.0625C13.5605 8.78125 14 8.37109 14 7.84375V6.90625C14 6.4082 13.5605 5.96875 13.0625 5.96875Z",
    fill: "#1F4760"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.cab5a897a6615411a9cba648239c21a3.svg";
export { ForwardRef as ReactComponent };